module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABCklEQVR4AWOgC7gnIQFBN5RVzpuYrtd2WxkRtig6YoJu6AlLmxsqKnAF6BqWBYbo9s7J5fMKz4ny74srKXdIqG1dFxCIU8MtRaVJzdMPxeaejUw4F514IjN3Z1n9PWVldA3/YeDfly+vbKz+3731o7/3e1fn/zt3ntna/v3yBa4AXcPfjx+/Hzv2Mj39w5QpH6ZNe5maCuQCBXFq+Pf794eZM9+1tb3v7QWid+3tQG14Nfz48SLA/8umTW8bGt7U1n7ZsuWFr8+/L59xa/j379vrd6+CAj7Onfdx4cKXgf7f3r4HCqJrYNDsgSMBnc7zG/bfLa2+U1hxZfN+Id0OZFmEBjyIMg2DEgAAScAJxZ7/xOcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/HR.png
// module id = 1161
// module chunks = 0